import { LegalLayout, LegalSection } from "@/components/landing/LegalLayout";
import { PHONE_DISPLAY, PHONE_TEL, EMAIL, EMAIL_MAILTO } from "@/constants/site";

export default function MentionsLegales() {
    return (
        <LegalLayout title="Mentions légales" testid="legal-mentions-page">
            <LegalSection title="Éditeur du site">
                <p>
                    Le site Pare Brise Paris est édité par la société Pare Brise Paris,
                    spécialiste du remplacement et de la réparation de pare-brise à domicile.
                </p>
                <p>
                    Téléphone :{" "}
                    <a href={PHONE_TEL} className="text-gold-dark font-medium hover:underline">
                        {PHONE_DISPLAY}
                    </a>
                    <br />
                    Email :{" "}
                    <a href={EMAIL_MAILTO} className="text-gold-dark font-medium hover:underline">
                        {EMAIL}
                    </a>
                </p>
            </LegalSection>

            <LegalSection title="Directeur de la publication">
                <p>Le directeur de la publication est le représentant légal de Pare Brise Paris.</p>
            </LegalSection>

            <LegalSection title="Hébergement">
                <p>
                    Ce site est hébergé par{" "}
                    <a
                        href="https://www.hostinger.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-gold-dark font-medium hover:underline"
                    >
                        Hostinger
                    </a>
                    .
                </p>
            </LegalSection>

            <LegalSection title="Propriété intellectuelle">
                <p>
                    L'ensemble des contenus présents sur ce site (textes, images, logo, vidéos,
                    éléments graphiques) est la propriété exclusive de Pare Brise Paris, sauf
                    mention contraire. Toute reproduction, représentation, modification ou diffusion,
                    totale ou partielle, sans autorisation écrite préalable est interdite.
                </p>
            </LegalSection>

            <LegalSection title="Données personnelles">
                <p>
                    Les informations concernant la collecte et le traitement de vos données
                    personnelles sont détaillées dans notre{" "}
                    <a href="/politique-confidentialite" className="text-gold-dark font-medium hover:underline">
                        Politique de confidentialité
                    </a>
                    .
                </p>
            </LegalSection>

            <LegalSection title="Cookies">
                <p>
                    Ce site n'utilise aucun cookie publicitaire ou de suivi. Seuls des cookies
                    strictement nécessaires au fonctionnement technique peuvent être déposés.
                </p>
            </LegalSection>

            <LegalSection title="Droit applicable">
                <p>
                    Les présentes mentions légales sont soumises au droit français. En cas de
                    litige, les tribunaux français seront seuls compétents.
                </p>
            </LegalSection>
        </LegalLayout>
    );
}
